// layouts/Approval/index.js
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card } from '@mui/material';

function Approval() {
  return (
    <Card>
      <ArgonBox p={3} textAlign="center">
        <ArgonTypography variant="body2" color="text">
          No approval rules set for this catalogue.
        </ArgonTypography>
      </ArgonBox>
    </Card>
  );
}

export default Approval;
